<template>
    <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-card-body uk-width-1-1@m mt-5">
            <div class=" uk-width-1-1@m">
                <h2 class="uk-modal-title">Création d'utilisateurs</h2> <br>
            <form @submit.prevent="createUtilisateurs">
            <fieldset class="uk-fieldset">
           <div uk-grid class="uk-margin ">
                <div class="uk-width-1-2">
                <input class="uk-input" type="text" v-model="utilisateur.nom" placeholder="Nom complet" required>
            </div>
            <div class="uk-width-1-2">
                <input class="uk-input" type="email" v-model="utilisateur.email" placeholder="Email" required>
            </div>
           </div>
            <div class="uk-margin" uk-grid>
                <div class="uk-width-1-2">
                <input class="uk-input" type="number" v-model="utilisateur.phone" placeholder="Téléphone" required>
            </div>
            <div class="uk-width-1-2">
                <input class="uk-input" type="password" v-model="utilisateur.password" placeholder="Mot de passe" required>
            </div>
            </div>
            <div class="uk-margin">
            <label >Rôle d'utilisateur</label>
            <select v-model="utilisateur.role" class="uk-select">
                <option>client</option>
                <option>livreur</option>
                <option>commercial</option>
                <option>superviseur</option>
                <option>logisticien</option>
                <option>administrateur</option>
            </select>
            </div>
        </fieldset>
       <div class="d-flex justify-content-center">
            <button class="btn-round my-1 border-0 px-5 uk-button uk-button-primary" style=" color:#fff;  font-size:1em !important; ">Valider</button>
       </div>
        </form>
            </div>
        </div>
    </div>
</template>
<script>
    import { db, dbstore, auth, fbfunctions } from '../../main';
    import Swal from "sweetalert2";
    export default {
    data(){
        return{
            utilisateur: {
                nom: "",
                email: "",
                phone: "",
                password:"",
                role:"",
                load:false
            },
        }
        
    },
    methods: {
    createUtilisateurs(event) {
      const user = this.utilisateur
        auth
        .createUserWithEmailAndPassword(user.email, user.password)
        .then((res) => {
          res.user.updateProfile({
            displayName: user.nom,
            phoneNumber: user.phone
          });

            if(user.role === 'client'){
                const addRole = fbfunctions.httpsCallable('addLivreurRole')
                addRole(user.email)
            }else if(user.role === 'livreur'){
                const addRole = fbfunctions.httpsCallable('addLivreurRole')
                addRole(user.email)
            }else if(user.role === 'commercial'){
                const addRole = fbfunctions.httpsCallable('addCommercialRole')
                addRole(user.email)
            }else if(user.role === 'superviseur'){
                const addRole = fbfunctions.httpsCallable('addSuperviseurRole')
                addRole(user.email)
            }else if(user.role === 'adminstrateur'){
                const addRole = fbfunctions.httpsCallable('addAdminRole')
                addRole(user.email)
            }else if(user.role === 'logisticien'){
                const addRole = fbfunctions.httpsCallable('addLogisticienRole')
                addRole(user.email)
            }

            Swal.fire({
                icon: "success",
                title: "Merci....",
                text: "compte créé avec succès!",
                allowOutsideClick: false,
              })

            event.target.reset();
            event.preventDefault();
          this.$router.push({ path: "/admin/gestion/utilisateurs" });
        })
        .catch((err) => {
          this.error = Swal.fire({
            icon: "error",
            title:
              '<span style="font-size:0.8em; color:red">Votre adresse e-mail existe déjà</span> ',
            allowOutsideClick: false,
            showConfirmButton: false,
          });
        });
    },
    }
}
</script>